"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ChangePassword_1 = __importDefault(require("../forms/components/change-password/ChangePassword"));
const Base_1 = require("./Base");
exports.default = ({ translations, onCloseModal, onSubmit, offline }) => {
    return ((0, jsx_runtime_1.jsx)(ModalBase, { onCloseModal: onCloseModal, children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ChangePassword_1.default, { translations: translations, onSubmit: onSubmit, offline: offline, onClose: onCloseModal }, void 0) }, void 0) }, void 0));
};
const ModalBase = (0, styled_components_1.default)(Base_1.ModalBase) `
  align-items: center;
  display: flex;
  justify-content: center;

  & > div {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    overflow: hidden;
    width: 30rem;
  }
`;
//# sourceMappingURL=ChangePassword.js.map